package com.neurobs.js.util

import java.time.Instant
import com.neurobs.util.SecondsTimestamp

import scala.scalajs.js
import scala.scalajs.js.Date

object StringUtilities {

	def timeString(d: SecondsTimestamp): String = {
		(new Date(d.instant.toEpochMilli)).toLocaleTimeString()
	}
	def dateString(d: SecondsTimestamp): String = {
		(new Date(d.instant.toEpochMilli)).toLocaleDateString()
	}
	def dateStringWithToday(d: SecondsTimestamp): String = {
		val date = dateString(d)
		val today = dateString(SecondsTimestamp.now())
		if (date == today) "Today" else date
	}
	def dateTimeString(d: SecondsTimestamp): String = {
		val dt = new Date(d.instant.toEpochMilli)
		s"${dt.toLocaleDateString()} ${dt.toLocaleTimeString()}"
	}
	def localToDateTime(s: String): Option[SecondsTimestamp] = {
		try {
			val localEpoch = Date.parse(s)
			if (localEpoch.isNaN || (localEpoch == 0)) None
			else {
				Some(SecondsTimestamp(Instant.ofEpochMilli(localEpoch.toLong)))
			}
		}
		catch {
			case _ : Throwable => None
		}
	}

}

object RandomString {
	private val chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
	private val charArray = chars.split("")

	def generate(length: Int): String = {
		(1 to length).map(_ => charArray(js.Math.floor(js.Math.random() * chars.length).toInt)).mkString("")
	}
}
